import { useState, useCallback, useRef } from 'react';
import mixPanel, { mixPanelEventsTypes } from 'helpers/mixPanel';
import { showReferAndEarnModal } from 'services/ProLine';

export enum ReferAndEarnSource {
    NAVIGATION_BAR = 'Navigation Bar',
    LINK = 'link',
}

export const useReferAndEarnPopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const openedOnceRef = useRef(false);

    const openPopup = useCallback((source: ReferAndEarnSource = ReferAndEarnSource.NAVIGATION_BAR) => {
        mixPanel.track(mixPanelEventsTypes.RAF_CTA_TRIGGERED, { source });
        showReferAndEarnModal().catch((err) => {
            if (!openedOnceRef.current) {
                openedOnceRef.current = true;
                mixPanel.track(mixPanelEventsTypes.RAF_POPUP_ERROR, {
                    missing_fields: ['script_or_api'],
                    error: err?.message ?? String(err ?? ''),
                });
                setIsOpen(true);
            }
        });
    }, []);
    const closePopup = useCallback(() => {
        setIsOpen(false);
        openedOnceRef.current = false;
    }, []);

    return {
        isOpen,
        openPopup,
        closePopup,
    };
};
